import axios from 'axios';

const crm = axios.create({
    baseURL: 'https://crm.dommusbeta.com.br'
});

export default crm;